// ── 상담자(콜 등록자)용 피드백 대기 벨 + 원탭 입력 ──────────────────────────
// 마케터가 운전 중 전화로 전달한 미팅 결과를 상담자가 일일콜현황에서 바로 기록한다.
// 목록은 기존 PendingFeedbackModal 재사용(tm_name 배지 = 담당 마케터),
// 입력은 선택지 칩 + 메모의 미니 모달 → PATCH /api/tm/feedback/:id (소유자 검증은 서버).
// 창은 FeedbackEntryModal(2026-11-03, 목록 결과 ✎ 수정·지우기와 같이 씀). refreshKey 가 바뀌면 대기 목록을 다시 센다
//   (목록에서 결과를 지우면 그 미팅이 대기로 돌아온다). onSaved: 넣은 뒤 일일콜 목록도 다시 읽게.
import React, { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { PendingFeedbackModal } from './PendingFeedbackModal';
import FeedbackEntryModal from './FeedbackEntryModal';

const bellBtnStyle = (count) => ({
  display: 'inline-flex', alignItems: 'center', gap: 6,
  padding: '7px 12px', borderRadius: 999, cursor: 'pointer',
  border: `1.5px solid ${count > 0 ? '#f59e0b' : 'var(--border)'}`,
  background: count > 0 ? 'rgba(245,158,11,0.12)' : 'var(--bg-card)',
  color: count > 0 ? '#b45309' : 'var(--text-muted)',
  fontSize: 12, fontWeight: 800, whiteSpace: 'nowrap',
});

export default function CallerPendingFeedback({ showToast, refreshKey = 0, onSaved }) {
  const [listOpen, setListOpen] = useState(false);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [target, setTarget] = useState(null);      // 결과 입력 중인 미팅
  const [saving, setSaving] = useState(false);

  const fetchList = useCallback(async () => {
    setLoading(true);
    const r = await apiClient.get('/api/tm/feedback/pending-caller');
    setLoading(false);
    if (r.ok) setList(r.data?.data || []);
  }, []);

  useEffect(() => { fetchList(); }, [fetchList, refreshKey]);

  async function save(selected, memo) {
    if (!selected) { showToast('피드백을 선택해 주세요.', 'error'); return; }
    setSaving(true);
    const r = await apiClient.patch(`/api/tm/feedback/${target.id}`, {
      feedback: selected,
      feedback_memo: memo.trim() || null,
    });
    setSaving(false);
    if (!r.ok) { showToast(r.data?.message || '피드백 저장에 실패했습니다.', 'error'); return; }
    showToast(`${target.company_name || '미팅'} 피드백 저장 완료`, 'success');
    setTarget(null);
    await fetchList();
    onSaved?.();
  }

  return (
    <>
      <button type="button" style={bellBtnStyle(list.length)} onClick={() => setListOpen(true)}>
        🔔 피드백 대기 {list.length > 0 ? <strong>{list.length}</strong> : '0'}건
      </button>

      {/* 대기 목록 — 마케터용 모달 재사용 (tm_name = 담당 마케터) */}
      <PendingFeedbackModal
        open={listOpen}
        onClose={() => setListOpen(false)}
        pendingLoading={loading}
        pendingList={list}
        adminMode
        onEntryClick={(item) => { setListOpen(false); setTarget(item); }}
      />

      {/* 결과 입력 미니 모달 — 선택지 칩 + 메모 (FeedbackEntryModal) */}
      <FeedbackEntryModal target={target} saving={saving} onClose={() => setTarget(null)} onSave={save} />
    </>
  );
}
